import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import { FilePond } from "react-filepond";
import { requestHeader } from "../../../../axios-project";
import Aux from "../../../../hoc/Auxilary.js";
import * as Yup from "yup";
import { Button } from "rsuite";

class documentsForm extends Component {
  render() {
    let { values } = this.props;
    console.log(values);

    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("file_name", true);
          this.props.setFieldTouched("file_url", true);
          this.props.setFieldTouched("file_type", true);
          this.props.setFieldTouched("security_level", true);
          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;
            console.log(values);
          func(values);
            this.props.toggleSmallModalHandler();
        }
      });
    };

    if (values.type === "picture" || values.type === "stakeholder_picture") {
      return (
        <Form key={"picture"} className={"form"}>
          <small className={"d-block"}><span style={{color:"red"}}>*</span> required</small>
          <label className={"d-block"}>
            File Source
            <Field
              name={"file_source"}
              className={"form-control"}
              value={this.props.values.file_source || ""}
            />
          </label>
            <div>
          <label className={"required"} htmlFor={"security_level"} style={this.props.errors.security_level && this.props.touched.security_level && {color: "red"}}>
            Security Level
              </label>
            <Field
                style={this.props.errors.security_level && this.props.touched.security_level && {borderColor: "red"}}
                id={"security_level"}
              name={"security_level"}
              className={"form-control"}
              component={"select"}
              value={this.props.values["security_level"] || "default"}
            >
              <option value="default" disabled>
                --Select one--
              </option>
              <option value="public">public</option>
              <option value="confidential">confidential</option>
            </Field>
          {this.props.errors.security_level &&
            this.props.touched.security_level && (
              <small className="text-danger">
                {this.props.errors.security_level}
              </small>
            )}
            </div>

          <label className={"d-block"}>
            File Description
            <Field
                component={"textarea"}
                name={"file_description"}
                className={"form-control"}
                value={this.props.values.file_description || ""}
            />
          </label>

            {!this.props.currentDocument ? (
            <div>
            <label className={"required"} htmlFor={"file_upload"}>
            Upload pictures here
            </label>
            <br/>
            {this.state && this.state.files && (
                (this.props.errors.file_name && this.props.touched.file_name)
                    ? (<small className="text-danger" style={{fontWeight: "bold"}}>Press upload button to the right</small> )
                    : ( <small className="text-danger">Press upload button to the right</small> )
            )}

            <FilePond
                id={"file_upload"}
              ref={ref => (this.pond = ref)}
              name={"file"}
              instantUpload={false}
              allowMultiple={false}
              maxFiles={100000}
              allowRevert={false}
              allowImageResize={true}
              imageResizeTargetWidth={270}
              server={{
                url: requestHeader.baseURL,
                load: {
                  url: "/downloadFile/",
                  headers: requestHeader.headers
                },
                remove: null,
                fetch: null,
                revert: null,
                process: {
                  url: "/uploadFile/",
                  headers: requestHeader.headers,
                  onload: response => {
                    response = JSON.parse(response);
                    this.props.values.file_url = response.fileDownloadUri;
                    this.props.values.file_name = response.fileName;
                    // this.props.values.file_type = response.fileName.split('.')[response.fileName.split('.').length - 1];
                    this.props.values.file_type = values.type;
                  }
                  // ondata: (formData) => {
                  //     formData.append('Hello', 'world')
                  //   console.log(formData);
                  // }
                }
              }}
              onupdatefiles={fileItems => {
                this.setState({
                  files: fileItems.map(fileItem => fileItem.file)
                });
              }}
            />
            </div>
            ) : null }
            {!this.props.currentDocument ? (
                <Aux>
                    <Button
                        type="button"
                        color="blue"
                        onClick={() => {
                            validAndHandle(this.props.add, this.props.values, values.type);
                        }}
                    >
                        Submit
                    </Button>
                    <Button
                        className="mx-2"
                        type="button"
                        onClick={this.props.toggleSmallModalHandler}
                        >
                    Cancel
                    </Button>
                </Aux>
            ) : (
                <Aux>
                    <Button
                        type="button"
                        color="blue"
                        onClick={() => {
                            validAndHandle(this.props.update, this.props.values, values.type);
                        }}
                    >
                        Update
                    </Button>
                    <Button
                        className="mx-2"
                        type="button"
                        onClick={this.props.toggleSmallModalHandler}
                    >
                        Cancel
                    </Button>
                </Aux>
            )}

        </Form>
      );
    } else if (values.type === "video" || values.type === "stakeholder_video") {
      return (
        <Form key={"video"}>
          <small className={"d-block"}><span style={{color:"red"}}>*</span> required</small>
          <div>
          <label className={"required"}  style={this.props.errors.file_name && this.props.touched.file_name && {color: "red"}}>
            File Name
          </label>

            <Field
                style={this.props.errors.file_name && this.props.touched.file_name && {borderColor: "red"}}
                name={"file_name"}
              className={"form-control"}
              value={this.props.values.file_name || ""}
            />
          {this.props.errors.file_name && this.props.touched.file_name && (
            <small className={"text-danger"}>{this.props.errors.file_name}</small>
          )}
            </div>

          <div>
          <label
              className={"required"}
               style={this.props.errors.file_url && this.props.touched.file_url && {color: "red"}}
          >
            Link URL
          </label>

            <Field
                style={this.props.errors.file_url && this.props.touched.file_url && {borderColor: "red"}}
                name={"file_url"}
              className={"form-control"}
              value={this.props.values.file_url || ""}
            />
          {this.props.errors.file_url && this.props.touched.file_url && (
            <small className="text-danger">{this.props.errors.file_url}</small>
          )}
          </div>
        <div>
          <label
              className={"required"}
              style={this.props.errors.security_level && this.props.touched.security_level && {color: "red"}}
          >
            Security Level
          </label>
            <Field
                style={this.props.errors.security_level &&
                this.props.touched.security_level ? {borderColor: "red"} : {}}
                name={"security_level"}
              component={"select"}
              className={"form-control"}
              value={this.props.values["security_level"] || "default"}
            >
              <option value="default" disabled>
                --Select one--
              </option>
              <option value="public">public</option>
              <option value="confidential">confidential</option>
            </Field>
          {this.props.errors.security_level &&
            this.props.touched.security_level && (
              <small className="text-danger">
                {this.props.errors.security_level}
              </small>
            )}
        </div>

          <label className={"d-block"}>
            File Description
            <Field
                component={"textarea"}
                name={"file_description"}
              className={"form-control"}
              value={this.props.values.file_description || ""}
            />
          </label>
          <label className={"d-block"}>
            File Source
            <Field
              name={"file_source"}
              className={"form-control"}
              value={this.props.values.file_source || ""}
            />
          </label>
            {!this.props.currentDocument ? (
                <Aux>
                    <Button
                        type="button"
                        color="blue"
                        onClick={() => {
                            this.props.values.file_type = values.type;
                            validAndHandle(this.props.add, this.props.values);
                        }}
                    >
                        Submit
                    </Button>
                    <Button
                        className="mx-2"
                        type="button"
                        onClick={this.props.toggleSmallModalHandler}
                    >
                        Cancel
                    </Button>
                </Aux>
            ) : (
                <Aux>
                    <Button
                        type="button"
                        color="blue"
                        onClick={() => {
                            this.props.values.file_type = values.type;
                            validAndHandle(this.props.update, this.props.values);
                        }}
                    >
                        Update
                    </Button>
                    <Button
                        className="mx-2"
                        type="button"
                        onClick={this.props.toggleSmallModalHandler}
                    >
                        Cancel
                    </Button>
                </Aux>
            )}
        </Form>
      );
    } else {
      return (
        <Form key={"others"}>
          <small className={"d-block"}><span style={{color:"red"}}>*</span> required</small>
            <div>
          <label className="required" htmlFor={"file_name"}  style={this.props.errors.file_name && this.props.touched.file_name && {color: "red"}}>
            File Name
          </label>
            <Field
                style={this.props.errors.file_name && this.props.touched.file_name && {borderColor: "red"}}
                id={"file_name"}
              className={"form-control"}
              name={"file_name"}
              value={this.props.values.file_name || ""}
            />
          {this.props.errors.file_name && this.props.touched.file_name && (
            <small className="text-danger">{this.props.errors.file_name}</small>
          )}
            </div>

            <div>
            <label
                className="required"
                htmlFor={"file_url"}
                style={this.props.errors.file_url && this.props.touched.file_url && {color: "red"}}>
            Link URL
            </label>

            <Field
                style={this.props.errors.file_url && this.props.touched.file_url && {borderColor: "red"}}
                id={"file_url"}
              className={"form-control"}
              name={"file_url"}
              value={this.props.values.file_url || ""}
            />
          {this.props.errors.file_url && this.props.touched.file_url && (
            <small className="text-danger">{this.props.errors.file_url}</small>
          )}
            </div>

            <div>
            <label
                style={this.props.errors.file_type && this.props.touched.file_type && {color: "red"}}
                className="required"
                htmlFor={"file_type"}>
            File Type
            </label>

            <Field
                style={this.props.errors.file_type && this.props.touched.file_type && {borderColor: "red"}}
                id={"file_type"}
              className={"form-control"}
              name={"file_type"}
              component={"select"}
              value={this.props.values["file_type"] || "default"}
            >
              <option value="default" disabled>
                --Select one--
              </option>
              <option value="image">Image</option>
              <option value="other">Other</option>
            </Field>
                {this.props.errors.file_type && this.props.touched.file_type && (
                    <small className="text-danger">{this.props.errors.file_type}</small>
                )}
            </div>

            <div>
            <label
                style={this.props.errors.security_level && this.props.touched.security_level && {color: "red"}}
                className="required"
                htmlFor={"security_level"}>
            Security Level
            </label>

            <Field
                style={this.props.errors.security_level && this.props.touched.security_level && {borderColor: "red"}}
                className={"form-control"}
              name={"security_level"}
              component={"select"}
              value={this.props.values["security_level"] || "default"}
            >
              <option value="default" disabled>
                --Select one--
              </option>
              <option value="public">public</option>
              <option value="confidential">confidential</option>
            </Field>
          {this.props.errors.security_level &&
            this.props.touched.security_level && (
              <small className="text-danger">
                {this.props.errors.security_level}
              </small>
            )}
            </div>

          <label className={"d-block"}>
            File Description
            <Field
                component={"textarea"}
                className={"form-control"}
              name={"file_description"}
              value={this.props.values.file_description || ""}
            />
          </label>
          <label className={"d-block"}>
            File Source
            <Field
              className={"form-control"}
              name={"file_source"}
              value={this.props.values.file_source || ""}
            />
          </label>
            {!this.props.currentDocument ? (
                <Aux>
                    <Button
                        type="button"
                        color="blue"
                        onClick={() => {
                            validAndHandle(this.props.add, this.props.values);
                        }}
                    >
                        Submit
                    </Button>
                    <Button
                        className="mx-2"
                        type="button"
                        onClick={this.props.toggleSmallModalHandler}
                    >
                        Cancel
                    </Button>
                </Aux>
            ) : (
                <Aux>
                    <Button
                        type="button"
                        color="blue"
                        onClick={() => {
                            validAndHandle(this.props.update, this.props.values);
                        }}
                    >
                        Update
                    </Button>
                    <Button
                        className="mx-2"
                        type="button"
                        onClick={this.props.toggleSmallModalHandler}
                    >
                        Cancel
                    </Button>
                </Aux>
            )}
        </Form>
      );
    }
  }
}

var fileUploadSchema = Yup.object().shape({
  security_level: Yup.string().required(),
  file_name: Yup.string().required(),
  file_url: Yup.string().required(),
  file_type: Yup.string().required()
});

export default withFormik({
  validationSchema: fileUploadSchema,

  mapPropsToValues({ currentDocument, type }) {
    return {
      ...currentDocument,
        type
    };
  }
})(documentsForm);
